import { useEffect } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { Layout } from '@insights_module/components/Layout';
import { withTitle } from '@hoc/withTitle';
import { useUser } from '@auth_module/hooks/useUser';
import { DateIntervalSelection } from '@insights_module/components/overview_screen/DateIntervalSelection';
import { TrendingTopNamedEntitiesList } from '@insights_module/components/overview_screen/TrendingTopNamedEntitiesList';
import { TrendingTopCategoriesList } from '@insights_module/components/overview_screen/TrendingTopCategoriesList';
import { GarmAnalysisChart } from '@insights_module/components/overview_screen/GarmAnalysisChart';
import { GarmCategoriesBrakeChart } from '@insights_module/components/overview_screen/GarmCategoriesBrakeChart';
import { GarmCategoryChart } from '@insights_module/components/overview_screen/GarmCategoryChart';
import { SidebarToggleButton } from '@insights_module/components/SidebarToggleButton';

const SectionWrapper = tw.div`flex flex-col w-full p-[24px] pt-[16px] gap-[16px]`;
const Title = tw.h2`text-[16px] font-semibold text-text-and-icon`;
const InnerWrapper = tw.div`flex flex-col sm:flex-row gap-[12px] self-stretch`;
const SectionHeader = tw.div`flex justify-start items-center w-full gap-[16px]`;
const Divider = tw.div`w-[calc(100% - 48px)] h-[0px] ml-[24px] border-b border-b-gray-1`;

const _OverviewPage = () => {
  const { t } = useTranslation();
  const { isCastedUserReady, notifyCastedUser } = useUser();

  useEffect(() => {
    if (isCastedUserReady) {
      notifyCastedUser();
    }
  }, [isCastedUserReady]);

  return (
    <Layout.InsightsPage>
      <div tw='h-full overflow-y-auto flex flex-col'>
        <div tw='sticky top-0 z-10 bg-neutral-background sm:border-b sm:border-solid sm:border-gray-3'>
          <div tw='flex items-center justify-start bg-page-background sm:h-[40px]'>
            <SidebarToggleButton tw='mx-[24px]' />
            <DateIntervalSelection />
          </div>
        </div>

        <div tw='grow overflow-y-auto pb-[24px]'>
          <SectionWrapper>
            <Title>{t('insights.overview_page.trending_section.title')}</Title>
            <InnerWrapper>
              <TrendingTopCategoriesList />
              <TrendingTopNamedEntitiesList />
            </InnerWrapper>
          </SectionWrapper>
          <Divider />

          <SectionWrapper>
            <SectionHeader>
              <Title>{t('insights.overview_page.brand_safety_section.title')}</Title>
            </SectionHeader>

            <InnerWrapper>
              <GarmAnalysisChart />
              <GarmCategoriesBrakeChart />
            </InnerWrapper>

            <InnerWrapper>
              <GarmCategoryChart />
            </InnerWrapper>
          </SectionWrapper>
        </div>
      </div>
    </Layout.InsightsPage>
  );
};

export const OverviewPage = withTitle(_OverviewPage, 'insights.overview_page.title');
